import $ from 'jquery';
import { generateIconElement, ICON } from "../../Icons/Icons";

/**
 * DeleteConfirmationModal - A component for showing confirmation modal when trying to delete a space
 */
class DeleteConfirmationModal {
  /**
   * Get the modal template
   * @param {string} spaceName - Name of the space being deleted
   * @returns {string} HTML template
   */
  modalTemplate(spaceName) {
    return `
<div class="confirm-modal confirm-modal--light-theme middle space-select-modal">
  <div class="confirm-dialog">
    ${generateIconElement(ICON.CLOSE, { classes: 'confirm-close' }).prop('outerHTML')}
    
    <div class="space-select-modal__title" data-lang="delete-space-confirmation-title">
      Are you sure you want to delete "${spaceName}"?
    </div>
    
    <div class="space-select-modal__subtitle" style="margin-top: 10px; color: #666; font-size: 14px;" data-lang="delete-space-confirmation-subtitle">
      This action cannot be undone. All data in this space will be permanently lost.
    </div>
    
    <div class="confirm-footer my-5">
      <button id="cancel_delete" class="buttn secondary" data-lang="cancel-text">
        Cancel
      </button>
      
      <button id="confirm_delete" class="buttn primary" style="background-color: #dc3545; border-color: #dc3545;" data-lang="delete-text">
        Delete
      </button>
    </div>
  </div>
</div>
    `;
  }

  /**
   * Constructor
   * @param {Object} options - Configuration options
   * @param {string} options.spaceName - Name of the space being deleted
   * @param {string} options.deleteUrl - URL to redirect to for deletion
   */
  constructor(options = {}) {
    console.log('DeleteConfirmationModal: Constructor called with options:', options);
    this.spaceName = options.spaceName || 'this space';
    this.deleteUrl = options.deleteUrl;

    this.render();
    this.addEventListeners();
    console.log('DeleteConfirmationModal: Modal initialized');
  }

  /**
   * Render the modal
   */
  render() {
    this.$modal = $(this.modalTemplate(this.spaceName));
    $('body').append(this.$modal);

    this.$elements = {
      $cancelDelete: this.$modal.find('#cancel_delete'),
      $confirmDelete: this.$modal.find('#confirm_delete'),
      $close: this.$modal.find('.confirm-close')
    };
  }

  /**
   * Add event listeners
   */
  addEventListeners() {
    // Cancel button - hide modal
    this.$elements.$cancelDelete.on('click', () => {
      console.log('DeleteConfirmationModal: Cancel button clicked');
      this.hide();
    });

    // Close button - hide modal
    this.$elements.$close.on('click', () => {
      console.log('DeleteConfirmationModal: Close button clicked');
      this.hide();
    });

    // Confirm delete button - submit POST request to delete URL
    this.$elements.$confirmDelete.on('click', () => {
      if (this.deleteUrl) {
        // Create a form and submit it with POST method
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = this.deleteUrl;

        // Add CSRF token if available
        if (window.yii && window.yii.getCsrfToken) {
          const csrfInput = document.createElement('input');
          csrfInput.type = 'hidden';
          csrfInput.name = window.yii.getCsrfParam();
          csrfInput.value = window.yii.getCsrfToken();
          form.appendChild(csrfInput);
        } else if ($('meta[name="csrf-token"]').length) {
          const csrfInput = document.createElement('input');
          csrfInput.type = 'hidden';
          csrfInput.name = '_token';
          csrfInput.value = $('meta[name="csrf-token"]').attr('content');
          form.appendChild(csrfInput);
        }

        document.body.appendChild(form);
        form.submit();
      }
    });

    // Click outside modal to close
    this.$modal.on('click', (e) => {
      if (e.target === this.$modal[0]) {
        this.hide();
      }
    });

    // Escape key to close
    $(document).on('keydown.deleteModal', (e) => {
      if (e.key === 'Escape') {
        this.hide();
      }
    });
  }

  /**
   * Show the modal
   */
  show() {
    console.log('DeleteConfirmationModal: Showing modal');
    this.$modal.addClass('visible');
    console.log('DeleteConfirmationModal: Modal classes:', this.$modal.attr('class'));
  }

  /**
   * Hide the modal
   */
  hide() {
    console.log('DeleteConfirmationModal: Hiding modal');
    this.$modal.removeClass('visible');
    // Remove escape key listener when hiding
    $(document).off('keydown.deleteModal');

    // Auto-destroy after hiding to prevent modal accumulation
    setTimeout(() => {
      this.destroy();
    }, 300);
  }

  /**
   * Destroy the modal and remove from DOM
   */
  destroy() {
    if (this.$modal && this.$modal.length) {
      console.log('DeleteConfirmationModal: Destroying modal');
      $(document).off('keydown.deleteModal');
      this.$modal.remove();
      this.$modal = null;
    }
  }
}

export default DeleteConfirmationModal;
